import {
  ADD_FILE_TO_FOLDER,
  ADD_FILE_TO_FOLDER_FAIL,
  ADD_FILE_TO_FOLDER_SUCCESS,
  ASSIGN_FOLDERS,
  ASSIGN_FOLDERS_FAIL,
  ASSIGN_FOLDERS_SUCCESS,
  CREATE_FOLDER,
  CREATE_FOLDER_FAIL,
  CREATE_FOLDER_SUCCESS,
  DELETE_FOLDER,
  DELETE_FOLDER_FAIL,
  DELETE_FOLDER_FILES,
  DELETE_FOLDER_FILES_FAIL,
  DELETE_FOLDER_FILES_SUCCESS,
  DELETE_FOLDER_SUCCESS,
  GET_ASSIGNED_MEMBERS,
  GET_ASSIGNED_MEMBERS_FAIL,
  GET_ASSIGNED_MEMBERS_SUCCESS,
  GET_FOLDERS,
  GET_FOLDERS_FAIL,
  GET_FOLDERS_SUCCESS,
  GET_FOLDER_FILES,
  GET_FOLDER_FILES_FAIL,
  GET_FOLDER_FILES_SUCCESS,
  REMOVE_FOLDER_USER,
  REMOVE_FOLDER_USER_FAIL,
  REMOVE_FOLDER_USER_SUCCESS,
  RENAME_FOLDER,
  RENAME_FOLDER_FAIL,
  RENAME_FOLDER_SUCCESS,
  UPDATE_FOLDER_PERMISSION,
  UPDATE_FOLDER_PERMISSION_FAIL,
  UPDATE_FOLDER_PERMISSION_SUCCESS,
} from "./actionTypes";

export const renameFolder = data => ({
  type: RENAME_FOLDER,
  payload: data,
});

export const renameFolderSuccess = data => ({
  type: RENAME_FOLDER_SUCCESS,
  payload: data,
});

export const renameFolderFail = data => ({
  type: RENAME_FOLDER_FAIL,
  payload: data,
});

export const removeFolderUser = data => ({
  type: REMOVE_FOLDER_USER,
  payload: data,
});

export const removeFolderUserSuccess = data => ({
  type: REMOVE_FOLDER_USER_SUCCESS,
  payload: data,
});

export const removeFolderUserFail = data => ({
  type: REMOVE_FOLDER_USER_FAIL,
  payload: data,
});

export const updateFolderPermission = data => ({
  type: UPDATE_FOLDER_PERMISSION,
  payload: data,
});

export const updateFolderPermissionSuccess = data => ({
  type: UPDATE_FOLDER_PERMISSION_SUCCESS,
  payload: data,
});

export const updateFolderPermissionFail = data => ({
  type: UPDATE_FOLDER_PERMISSION_FAIL,
  payload: data,
});

export const getAssignedMembers = data => ({
  type: GET_ASSIGNED_MEMBERS,
  payload: data,
});

export const getAssignedMembersSuccess = data => ({
  type: GET_ASSIGNED_MEMBERS_SUCCESS,
  payload: data,
});

export const getAssignedMembersFail = data => ({
  type: GET_ASSIGNED_MEMBERS_FAIL,
  payload: data,
});

export const assignFolders = data => ({
  type: ASSIGN_FOLDERS,
  payload: data,
});

export const assignFoldersSuccess = data => ({
  type: ASSIGN_FOLDERS_SUCCESS,
  payload: data,
});

export const assignFoldersFail = data => ({
  type: ASSIGN_FOLDERS_FAIL,
  payload: data,
});

export const deleteFolder = data => ({
  type: DELETE_FOLDER,
  payload: data,
});

export const deleteFolderSuccess = data => ({
  type: DELETE_FOLDER_SUCCESS,
  payload: data,
});

export const deleteFolderFail = data => ({
  type: DELETE_FOLDER_FAIL,
  payload: data,
});

export const deleteFolderFiles = data => ({
  type: DELETE_FOLDER_FILES,
  payload: data,
});

export const deleteFolderFilesSuccess = data => ({
  type: DELETE_FOLDER_FILES_SUCCESS,
  payload: data,
});

export const deleteFolderFilesFail = data => ({
  type: DELETE_FOLDER_FILES_FAIL,
  payload: data,
});

export const addFileToFolder = (data, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_FILE_TO_FOLDER,
  payload: { data, onError, onSuccess },
});

export const addFileToFolderSuccess = data => ({
  type: ADD_FILE_TO_FOLDER_SUCCESS,
  payload: data,
});

export const addFileToFolderFail = data => ({
  type: ADD_FILE_TO_FOLDER_FAIL,
  payload: data,
});

export const getFoldersFile = data => ({
  type: GET_FOLDER_FILES,
  payload: data,
});

export const getFoldersFileSuccess = data => ({
  type: GET_FOLDER_FILES_SUCCESS,
  payload: data,
});

export const getFoldersFileFail = data => ({
  type: GET_FOLDER_FILES_FAIL,
  payload: data,
});

export const createFolder = data => ({
  type: CREATE_FOLDER,
  payload: data,
});

export const createFolderSuccess = data => ({
  type: CREATE_FOLDER_SUCCESS,
  payload: data,
});

export const createFolderFail = data => ({
  type: CREATE_FOLDER_FAIL,
  payload: data,
});

export const getFolders = data => ({
  type: GET_FOLDERS,
  payload: data,
});

export const getFoldersSuccess = data => ({
  type: GET_FOLDERS_SUCCESS,
  payload: data,
});

export const getFoldersFail = data => ({
  type: GET_FOLDERS_FAIL,
  payload: data,
});
